import React from "react";
import { ModeRendererProps } from "./types";

export function VasarelyLeCorbusierMode({ brand }: ModeRendererProps) {
  // Modular harmony: architectural rationalism meets optical geometry
  // Based on Le Corbusier's Modulor ratios (golden ratio system)
  const phi = 1.618; // Golden ratio
  
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill={brand.paper} />
      
      {/* Modulor vertical divisions */}
      {Array.from({ length: 8 }).map((_, i) => {
        const x = 60 + i * 89; // Modulor-inspired spacing
        return (
          <line
            key={`vert-${i}`}
            x1={x}
            y1="60"
            x2={x}
            y2="1060"
            stroke={brand.deep}
            strokeWidth="2"
            opacity={0.3}
          />
        );
      })}
      
      {/* Horizontal Modulor grid */}
      {Array.from({ length: 12 }).map((_, i) => {
        const y = 60 + i * 83;
        return (
          <line
            key={`horiz-${i}`}
            x1="60"
            y1={y}
            x2="730"
            y2={y}
            stroke={brand.deep}
            strokeWidth="2"
            opacity={0.3}
          />
        );
      })}
      
      {/* Architectural facade blocks */}
      <rect x="80" y="100" width="144" height="233" fill={brand.aqua} opacity={0.7} />
      <rect x="244" y="100" width="89" height="144" fill={brand.violet} opacity={0.8} />
      <rect x="353" y="100" width="144" height="144" fill={brand.deep} opacity={0.9} />
      <rect x="517" y="100" width="89" height="233" fill={brand.amber} opacity={0.7} />
      
      {/* Vasarely optical distortions on facade */}
      {Array.from({ length: 6 }).map((_, i) => {
        const size = 120 - i * 18;
        const offset = i * 9;
        return (
          <rect
            key={`optical-${i}`}
            x={160 + offset}
            y={140 + offset}
            width={size}
            height={size}
            fill="none"
            stroke={brand.white}
            strokeWidth="2"
            opacity={0.8 - i * 0.12}
          />
        );
      })}
      
      {/* Middle section - structured fields */}
      <rect x="80" y="353" width="233" height="144" fill={brand.violet} opacity={0.6} />
      <rect x="333" y="353" width="144" height="144" fill={brand.aqua} opacity={0.7} />
      <rect x="497" y="353" width="233" height="144" fill={brand.white} stroke={brand.deep} strokeWidth="2" />
      
      {/* Circular optical elements */}
      {Array.from({ length: 10 }).map((_, i) => {
        const r = 8 + i * 7;
        return (
          <circle
            key={`circle-${i}`}
            cx={405}
            cy={425}
            r={r}
            fill="none"
            stroke={brand.amber}
            strokeWidth="1.5"
            opacity={0.7 - i * 0.05}
          />
        );
      })}
      
      {/* Lower architectural modules */}
      <rect x="80" y="517" width="144" height="233" fill={brand.amber} opacity={0.7} />
      <rect x="244" y="517" width="233" height="144" fill={brand.deep} opacity={0.8} />
      <rect x="497" y="517" width="89" height="144" fill={brand.aqua} opacity={0.9} />
      <rect x="606" y="517" width="124" height="233" fill={brand.violet} opacity={0.6} />
      
      <rect x="244" y="681" width="144" height="69" fill={brand.white} stroke={brand.deep} strokeWidth="2" />
      <rect x="408" y="681" width="69" height="69" fill={brand.amber} opacity={0.8} />
      
      {/* Bottom section with fine grid overlay */}
      <rect x="80" y="770" width="650" height="220" fill={brand.paper} stroke={brand.deep} strokeWidth="3" />
      
      {Array.from({ length: 8 }).map((_, row) =>
        Array.from({ length: 16 }).map((_, col) => (
          <rect
            key={`grid-${row}-${col}`}
            x={90 + col * 40}
            y={780 + row * 26}
            width={36}
            height={22}
            fill="none"
            stroke={brand.violet}
            strokeWidth="0.5"
            opacity={0.3}
          />
        ))
      )}
    </g>
  );
}
